export default __webpack_public_path__ + "static/context-3bbb9dd1204a90e570b1b051522e979a.png";